import { render, staticRenderFns } from "./MyMediaItems.vue?vue&type=template&id=b942e324&scoped=true&"
import script from "./MyMediaItems.vue?vue&type=script&lang=js&"
export * from "./MyMediaItems.vue?vue&type=script&lang=js&"
import style0 from "./MyMediaItems.vue?vue&type=style&index=0&id=b942e324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b942e324",
  null
  
)

export default component.exports